import {useEffect} from "react";
import { useSelector,useDispatch } from "react-redux"
import { podcastRequest } from "features/Podcast/podcastSlice";
 

const usePodcastList = (start,limit) => {
   const dispatch = useDispatch();

   useEffect(()=>{
     dispatch(podcastRequest([start,limit]));
   },[start,limit,dispatch]);

   return useSelector((state)=>{
     if(state.podcast.podcastArray) return state.podcast.podcastArray;
     return [];
   })
}

export default usePodcastList;
